import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Trophy } from "lucide-react";
import { lei } from "@/components/ads/GoogleConnect";
import { MA } from "@/components/ads/MetaWizard";

const Card = ({ r, rank }) => (
  <div className="flex gap-3 rounded-xl border border-zinc-800 bg-zinc-900/60 p-3" data-testid={`meta-winner-${r.ad_id}`}>
    <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-lg bg-zinc-800">
      {r.image && <img src={r.image} alt="" loading="lazy" className="h-full w-full object-cover" />}
      <span className="absolute left-1 top-1 rounded bg-zinc-950/80 px-1.5 text-[10px] font-bold text-amber-300">#{rank}</span>
    </div>
    <div className="min-w-0 flex-1 space-y-1 text-xs">
      <p className="truncate font-medium text-zinc-100">{r.name}</p>
      <p className="truncate text-zinc-500">{r.campaign} · <span className={r.source === "bragusapp" ? "text-amber-300" : ""}>{r.source === "bragusapp" ? "din Creative Ads" : "din Ads Manager"}</span></p>
      <p className="text-zinc-300"><b>{r.purchases}</b> vânzări · {lei(r.value)} · ROAS <b>{r.roas}</b></p>
      <p className="text-zinc-500">Cheltuit {lei(r.spend)} · cost/vânzare {r.cpa ? lei(r.cpa) : "—"} · CTR {r.ctr}%</p>
    </div>
  </div>
);

export const MetaWinners = ({ days }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { setD(null); setErr(""); axios.get(`${MA}/winners`, { params: { days }, timeout: 90000 }).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || e.message)); }, [days]);
  const rows = (d?.items || []).filter((r) => r.spend > 0);
  return (
    <div className="space-y-3" data-testid="meta-winners">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-zinc-200"><Trophy className="h-4 w-4 text-amber-400" /> Creative câștigătoare <span className="font-normal text-zinc-500">— după vânzări, apoi ROAS</span></h3>
      {err ? <p className="text-xs text-rose-300">{err}</p> : !d ? <Loader2 className="h-4 w-4 animate-spin text-zinc-500" />
        : !rows.length ? <p className="text-xs text-zinc-500" data-testid="meta-winners-empty">Nicio reclamă cu cheltuieli în perioadă.</p>
        : <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">{rows.slice(0, 12).map((r, i) => <Card key={r.ad_id} r={r} rank={i + 1} />)}</div>}
      <p className="text-[11px] text-zinc-500">Creativele făcute în BragusApp și publicate cu „Reclamă Meta” apar marcate „din Creative Ads”.</p>
    </div>
  );
};
